/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Faq5a_Billinglink2Inputs */

const zh_pricing_faq5a_billinglink2 = /** @type {(inputs: Pricing_Faq5a_Billinglink2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`账单页面`)
};

const en_pricing_faq5a_billinglink2 = /** @type {(inputs: Pricing_Faq5a_Billinglink2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Billing Page`)
};

const es_pricing_faq5a_billinglink2 = /** @type {(inputs: Pricing_Faq5a_Billinglink2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`página de Facturación`)
};

/**
* | output |
* | --- |
* | "Billing Page" |
*
* @param {Pricing_Faq5a_Billinglink2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const pricing_faq5a_billinglink2 = /** @type {((inputs?: Pricing_Faq5a_Billinglink2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Faq5a_Billinglink2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_pricing_faq5a_billinglink2(inputs)
	if (locale === "en") return en_pricing_faq5a_billinglink2(inputs)
	return es_pricing_faq5a_billinglink2(inputs)
});
export { pricing_faq5a_billinglink2 as "pricing_faq5A_billingLink" }